import { iconNames, Colors } from '@zapier/design-system';
import { COLOR_KEYS, ICON_NAMES } from '../../constants';
export const featuresSectionConfig = {
    name: 'FeaturesSection',
    category: 'Zapier Sections',
    includeScrollTracking: true,
    image: 'https://cdn.zappy.app/3b63769509bdbf871755043401aa0e19.svg',
    inputs: [
        {
            name: 'backgroundColor',
            type: 'string',
            enum: Object.values(COLOR_KEYS),
            defaultValue: COLOR_KEYS.neutral100,
        },
        {
            name: 'textColor',
            enum: [...Object.keys(Colors)],
            type: 'string',
            defaultValue: COLOR_KEYS.neutral800,
            required: true,
        },
        {
            name: 'tag',
            type: 'string',
            enum: ['h2', 'h3', 'h4', 'h5', 'h6'],
            required: true,
            defaultValue: 'h3'
        },
        {
            name: 'features',
            type: 'list',
            required: true,
            subFields: [
                {
                    name: 'icon',
                    type: 'string',
                    enum: ['', ...Object.keys(iconNames)],
                    required: true,
                    defaultValue: ICON_NAMES.actionAttachment,
                },
                {
                    name: 'iconColor',
                    type: 'string',
                    enum: ['', ...Object.keys(Colors)],
                    defaultValue: COLOR_KEYS.zapier,
                },
                {
                    name: 'heading',
                    type: 'string',
                    defaultValue: 'Heading',
                    required: true,
                },
                {
                    name: 'description',
                    type: 'richText',
                    required: true,
                },
            ],
        },
    ],
};
//# sourceMappingURL=config.js.map